import {
  Container,
  HStack,
  Table,
  Tbody,
  Td,
  Text,
  Thead,
  Tr,
} from "@chakra-ui/react";
import { useParams, useSearchParams } from "react-router-dom";

import { DealerOrganizationPropertiesFilterBar } from "src/routes/DealerOrganization/DealerOrganizationPropertiesFilterBar";
import { useDealerPropertiesQuery } from "src/routes/DealerOrganization/queries";
import { Loading } from "src/common/Loading";
import { SortableTh } from "src/common/SortableTh";
import { PageContent } from "src/layout/PageContent";
import { SomethingWentWrong } from "src/common/ErrorBoundary/SomethingWentWrong";
import { PageHeader, PageHeaderTitle } from "src/layout/PageHeader";
import { Pagination } from "src/common/Pagination";

export const DealerOrganizationProperties = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const { id } = useParams<"id">();

  if (!id) {
    return (
      <Container maxW="7xl" h="calc(100vh)" centerContent={true}>
        <SomethingWentWrong
          error={new Error("Dealer Organization ID is not provided.")}
        />
      </Container>
    );
  }

  const properties = useDealerPropertiesQuery(id);

  if (properties.isError || properties.error) {
    return (
      <Container maxW="7xl" h="calc(100vh)" centerContent={true}>
        <SomethingWentWrong error={properties.error} />;
      </Container>
    );
  }

  if (!properties.data || properties.isLoading) {
    return <Loading />;
  }

  return (
    <PageContent>
      <PageHeader buttons={<DealerOrganizationPropertiesFilterBar />}>
        <PageHeaderTitle>Dealer Property Organizations</PageHeaderTitle>
      </PageHeader>

      <Table variant="simple">
        <Thead>
          <Tr>
            <SortableTh sortKey="propertyName">Property Name</SortableTh>
            <SortableTh sortKey="contactName">Contact Name</SortableTh>
            <SortableTh sortKey="address">Address</SortableTh>
            <SortableTh sortKey="propertyType">Property Type</SortableTh>
          </Tr>
        </Thead>
        <Tbody>
          {properties.data.result.map((property) => {
            return (
              <Tr key={property.propertyOrganizationId}>
                <Td>
                  <HStack>
                    <Text>{property.name || "-"}</Text>
                  </HStack>
                </Td>
                <Td>
                  {property.contact
                    ? [
                        property.contact?.user.firstName,
                        property.contact?.user.lastName,
                      ].join(" ")
                    : "-"}
                </Td>
                <Td>
                  {[
                    property.address,
                    property.city,
                    property.state,
                    property.zip,
                  ].join(", ")}
                </Td>
                <Td textTransform="capitalize">{property.propertyType}</Td>
              </Tr>
            );
          })}
        </Tbody>
      </Table>
      <Pagination
        unitName="property"
        unitPlural="properties"
        total={properties.data.total || properties.data.result.length || 0}
        pageNumber={parseInt(searchParams.get("pageNumber") || "1")}
        pageSize={20}
        onPageChange={(page) => {
          setSearchParams((prev) => {
            const next = new URLSearchParams(prev);
            next.set("pageNumber", page.toFixed(0));
            return next;
          });
        }}
      />
    </PageContent>
  );
};
